
/* eslint-disable */
/* global */

const env = process.env.NODE_ENV || 'development',
  config = require('../../config/config.json')[env]
  
import AWS from 'aws-sdk';
   AWS.config.update({
       accessKeyId:  config.aws.accessKeyId,
       secretAccessKey: config.aws.secretAccessKey,
       region: config.aws.region
   });

const s3 = new AWS.S3();

export async function upload (options) {
  let uploadError;
  let response;

  try {
    response = await s3.putObject(options).promise();
    return { uploadError, response };
  } catch (error) {
    return { uploadError: error };
  }
}


// WEBPACK FOOTER //
// ./src/helpers/aws.js